module.exports = __webpack_public_path__ + "img/silvana-russo-byn.09010d17.jpg";